module.exports = __webpack_public_path__ + "img/acuario michin.c3d09422.jpeg";